import { Box, Stack, Typography } from "@mui/material";
import { CenterPage } from "Components/CenterPage/CenterPage";
import GlassCard from "Components/GlassCard/GlassCard";
import { ReactNode } from "react";

interface ISelectEmptyStateProps {
  icon: ReactNode;
  title: string;
  dropdown: ReactNode;
  table?: ReactNode;
  calcHeight?: boolean;
}

function SelectEmptyState({
  icon,
  title,
  dropdown,
  table,
  calcHeight,
}: ISelectEmptyStateProps) {

  return (
    <CenterPage calcHeight={calcHeight}>
      <GlassCard
        boxProps={{
          px: { xs: 3, sm: 5 },
          py: 4,
          sx: { width: 800 },
        }}
      >
        <Stack spacing={3} alignItems="center" textAlign="center">
          <Box
            sx={{
              width: 72,
              height: 72,
              borderRadius: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              bgcolor: "rgba(201, 211, 244, 0.25)",
            }}
          >
            {icon}
          </Box>
          <Stack spacing={0.5}>
            <Typography variant="h4" fontWeight={600}>
              {title}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Choose from the dropdown
            </Typography>
          </Stack>
          {dropdown}
          {table && (
            <>
              <Typography color="text.secondary">
                Or pick from the table
              </Typography>
              <Box sx={{ height: 400, width: "100%", mt: 1 }}>
                {table}
              </Box>
            </>
          )}
        </Stack>
      </GlassCard>
    </CenterPage>
  );
}

export default SelectEmptyState;
